import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ArquivoUpload } from '../../arquivo-upload';

@Component({
    selector: 'sgt-arquivo-upload-table',
    templateUrl: 'arquivo-upload-table.component.html',
    styleUrls: ['./arquivo-upload-table.component.less']
})
export class ArquivoUploadTableComponent {
    @Input() canEdit = true;
    @Input() arquivosUpload: ArquivoUpload[];

    // Table
    @Input() idTable = 'tableArquivosUpload';
    dataTable: any;

    @Output() delete = new EventEmitter<number>();
}
